import React, { useState } from "react";
import { DietFormData } from "@/components/diet/types";
import { DietContext } from "./DietContext";
import { useTranslation } from "react-i18next";

export const DietProvider: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const { i18n } = useTranslation();

    const emptyFormData = (): DietFormData => ({
        type: "",
        age: "",
        height: "",
        weight: "",
        sex: "",
        lifestyle: "",
        target: "",
        excludedFoods: "",
        preferredFoods: "",
        medicalConditions: "",
        updateId: "",
        bmr: 0,
        tdee: 0,
        calories: 0,
        doc: "",
        language: i18n.language,
    });

    const [formData, setFormData] = useState<DietFormData>(emptyFormData());

    const [step, setStep] = useState(1);

    return (
        <DietContext.Provider
            value={{ formData, setFormData, step, setStep, emptyFormData }}
        >
            {children}
        </DietContext.Provider>
    );
};
